import React, { useState } from "react";

import { PartnerAccountCandidateDto, PartnerDto } from "services/partners/restModels";
import { formatPhoneNumber } from "shared/lib/phoneNumber";
import { Button } from "shared/ui/Button";
import { Modal } from "shared/ui/Modal";

import { DialogForm, MutedLine } from "../styles";
import { AccountSelect } from "./AccountSelect";

interface PartnerAccountDialogProps {
    partner: PartnerDto;
    saving: boolean;
    onClose: () => void;
    onSubmit: (accountId: number) => void;
}

export const PartnerAccountDialog = ({ partner, saving, onClose, onSubmit }: PartnerAccountDialogProps) => {
    const [candidate, setCandidate] = useState<PartnerAccountCandidateDto | null>(null);

    return (
        <Modal
            open
            onClose={onClose}
            title="Сменить аккаунт партнёра"
            maxWidth="xs"
            actions={
                <>
                    <Button variant="text" color="neutral" onClick={onClose} disabled={saving}>
                        Отмена
                    </Button>
                    <Button
                        onClick={() => candidate && onSubmit(candidate.accountId)}
                        disabled={saving || candidate === null}
                    >
                        Сменить
                    </Button>
                </>
            }
        >
            <DialogForm>
                {partner.phoneNumber && (
                    <MutedLine>
                        Сейчас: {formatPhoneNumber(partner.phoneNumber)}. Этот аккаунт потеряет доступ в
                        админку.
                    </MutedLine>
                )}
                <AccountSelect value={candidate} disabled={saving} onChange={setCandidate} />
            </DialogForm>
        </Modal>
    );
};
